module.exports = __webpack_public_path__ + "img/trash-can-arrow-up.d862490d.svg";